import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import NProgress from 'nprogress';
import { setSentryTags } from '@/utils/sentry';
import { forceReload } from '@/utils/force-reload';
import { layoutApi } from '@/api/login.js';
var routeMap = new Set(['/login', '/agreement', '/privacy', '/experience-login']);

function routerChecking(_x, _x2, _x3) {
  return _routerChecking.apply(this, arguments);
}

function _routerChecking() {
  _routerChecking = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var _JSON$parse, _localStorage$getItem;

    var uid;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            NProgress.start();
            uid = (_JSON$parse = JSON.parse((_localStorage$getItem = localStorage.getItem('userInfo')) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : null)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.uid;

            if (!(!uid && !routeMap.has(to.path))) {
              _context.next = 7;
              break;
            }

            _context.next = 5;
            return layoutApi();

          case 5:
            next('/login');
            return _context.abrupt("return");

          case 7:
            // safari强制刷新
            forceReload(to.path); // 设置sentry tag

            setSentryTags({
              uid: uid
            });
            next();
            NProgress.done();

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _routerChecking.apply(this, arguments);
}

export default routerChecking;